module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-100"
  }, [_c('img', {
    staticClass: "h-100 w-100 mx-auto",
    staticStyle: {
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.background_image
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77516b36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/player/page/center.vue
// module id = 114
// module chunks = 0